<!--
  TWS-107: `<ui-skip-link>` MUST be the first focusable element in the
  portal shell. It targets `#main-content` below.
-->
<ui-skip-link></ui-skip-link>
<div class="tw-layout"
     [attr.data-sidebar]="effectiveSidebar()"
     [attr.data-viewport-mobile]="viewportBelowBreakpoint() ? 'true' : null">
  <app-sidebar-nav class="tw-layout__sidebar"></app-sidebar-nav>
  <app-toolbar-nav class="tw-layout__topbar"></app-toolbar-nav>
  <!--
    B6 Wave 2: the layout-shell breadcrumb strip was removed. Every portal
    page now owns its own breadcrumb in-header via
    `<tw-page-header-breadcrumbs auto>` inside its `<tw-page-header>`. The
    `BreadcrumbService` + `BREADCRUMB_LABEL_RESOLVER` provider (below) and
    `PageTitleStrategy` wiring stay — the in-header `auto` mode + `setLabel`
    overrides still depend on them; only the shell's rendered strip is gone.
  -->
  <main id="main-content" class="tw-content" tabindex="-1">
    <router-outlet></router-outlet>
  </main>
  <app-footer class="tw-layout__footer"></app-footer>
  <app-mobile-sidebar-dialog></app-mobile-sidebar-dialog>
</div>
